import React from 'react'
import type { InterviewQuestionOptionsResource } from '@entities/api/Interview'
import { useFormContext } from 'react-hook-form'

interface Props {
  prefix: string
  itemName: string | null
  required: boolean
  options?: InterviewQuestionOptionsResource | null
}

const YesNo: React.FC<Props> = ({ prefix, itemName, required, options }) => {
  const { register, watch, setValue } = useFormContext()
  const inputName = `${prefix}.value`
  const dummyInputName = `_${inputName}`
  const value = watch(inputName)
  const errorPrefix = `${itemName ? `${itemName}について、` : ''}`

  let yesLabel = 'はい'
  let noLabel = 'いいえ'

  if (options?.yes_label) {
    yesLabel = options.yes_label
  }
  if (options?.no_label) {
    noLabel = options.no_label
  }

  const handleChangeRadio = (event) => {
    setValue(inputName, event.target.value)
  }

  return (
    <div className="row" data-toggle="buttons">
      <input
        ref={register({
          required: required && `${errorPrefix}${yesLabel} または ${noLabel}を選択してください`,
        })}
        type="hidden"
        name={inputName}
      />
      <div className="col-6 pr-2 form-group btn-group-toggle">
        <label
          id={`${dummyInputName}_yes`}
          className={`btn btn-light btn-block form-control ${value === 'yes' ? 'active' : ''}`}
        >
          <input
            type="radio"
            id={`${dummyInputName}_yes`}
            name={dummyInputName}
            value="yes"
            defaultChecked={value === 'yes'}
            className="btn-check"
            onClick={handleChangeRadio}
          />
          {yesLabel}
        </label>
      </div>
      <div className="col-6 pl-2 form-group btn-group-toggle">
        <label
          id={`${dummyInputName}_no`}
          className={`btn btn-light btn-block form-control ${value === 'no' ? 'active' : ''}`}
        >
          <input
            type="radio"
            id={`${dummyInputName}_no`}
            name={dummyInputName}
            value="no"
            defaultChecked={value === 'no'}
            className="btn-check"
            onClick={handleChangeRadio}
          />
          {noLabel}
        </label>
      </div>
    </div>
  )
}

export default YesNo
